<template>
	<div class="divcreateorder">
		<stock ref="stock" v-show="type == 'instockplan'||type == 'instock'||type == 'outstockplan'||type == 'outstock'||type=='outstock_loss'||type=='instock_more'"></stock>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import stock from '@/components/stockmanager/stock.vue';
export default {
	components: {
		stock
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: 'stock',
			orderinfo:{},
			isdetail:0,
			handletype:''
		};
	},
	mounted() {
		//debugger
		if (this.urlparam != undefined) {
			this.pageparam = this.urlparam;
			if (this.urlparam.pkval != undefined) {
				this.curpkval = this.urlparam.pkval;
				if (this.urlparam.iscopy != undefined) {
					this.iscopy = this.urlparam.iscopy;
				}
			}
			if(this.urlparam.isdetail!=undefined)
				this.isdetail=this.urlparam.isdetail;
			if(this.urlparam.orderinfo!=undefined)
				this.orderinfo=this.urlparam.orderinfo;
			debugger
			if(this.urlparam.l_tablename!=undefined)
				this.type=this.urlparam.l_tablename;
			if(this.urlparam.handletype!=undefined)
				this.handletype=this.urlparam.handletype;
			
			if (this.type == 'instockplan'||this.type == 'instock'||this.type == 'outstock'||this.type == 'outstockplan'||this.type=='outstock_loss'||this.type=='instock_more') {
				
				if (this.$refs.stock != undefined) {
					this.$refs.stock.init({pkval:this.curpkval,iscopy:this.iscopy,orderinfo:this.orderinfo,handletype:this.handletype,isdetail:this.isdetail,type:this.type});
				}
			}
		}
	}
};
</script>
